(function () {
  'use strict';

  angular.module('settings.popup', ['ui.bootstrap']);
})();
